import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { PortfolioLibraryCount, PortfolioLibraryItem, PortfolioStatus } from "../../models/Portfolio";
import { store } from "../reducers/store";
import { LeoService } from "../../services/leoService";

export const setPage = createAction<number>('portfoliosLibrary/setPage');

export const updaterCounter = createAction<{status: PortfolioStatus, change: number;}>('portfoliosLibrary/updaterCounter');

export const setViewType = createAction('portfoliosLibrary/setViewType', (state: PortfolioStatus) => {
    store.dispatch(loadPortfolioLibrary(state));
    return { payload: state };
});

export const loadPortfolioLibrary = createAsyncThunk<PortfolioLibraryItem[], PortfolioStatus>(
    'portfoliosLibrary/loadPortfolioLibrary',
    async (status: PortfolioStatus) => {
        const leoService = new LeoService();
        return await leoService.GetPorfolioLibraryItems(status)
    });

export const loadPortfolioCount = createAsyncThunk<PortfolioLibraryCount[]>(
    'portfoliosLibrary/loadPortfolioCount',
    async () => {
        const leoService = new LeoService();
        return await leoService.GetPorfolioLibraryCounts()
    });

export const deletePortfolio = createAsyncThunk<string,string>(
    'portfoliosLibrary/deletePortfolio',
    async (id) => {
        const leoService = new LeoService();
        await leoService.DeletePortfolioItem(id);
        return id;
    });

export const addFundToPortfolio = createAsyncThunk<string, {id: string, fundId: number}>(
    'portfoliosLibrary/addFundToPortfolio',
    async ({id, fundId}) => {
        const leoService = new LeoService();
        await leoService.AddFundToPortfolio(id, fundId);
        return id;
    });
